import React from 'react';
import { useOfficialStore } from '$/store/useOfficialStore';
import {
  Card, CardTitle, CardContent, CardHeader, CardGradientText,
} from '@/components/overseaHome/ui/Card';
import useIsMobile from '@/hooks/useIsMobile';
import { useCardExpo } from '@/hooks/useCardExpo';
import { useOfficialHomeContext } from '@/components/overseaHome/OfficialHomeContext';
import { OFFICIAL_HOME_LOCALIZED_CONTENT } from '@/components/overseaHome/localizedContent';
import VipCard from './VipCard';
import styles from './index.module.scss';

/** 按官网请求语言展示定价区域，并在首次进入视口时上报曝光。 */
export default function Pricing() {
  const isMobile = useIsMobile();
  const officialHome = useOfficialHomeContext();
  // 官网 SSR 与客户端共用请求语言，独立渲染时以英文兜底。
  const content = OFFICIAL_HOME_LOCALIZED_CONTENT[officialHome?.languageCode ?? 'en'].pricing;

  /** 价格区域首次进入可视区时，按触发瞬间的真实登录态上报一次曝光。 */
  const reportPricingExposure = () => {
    const isUserLoggedIn = useOfficialStore.getState().isUserLoggedIn();
    window.mtstat?.track('roboneo_official_page_vip_show', {
      is_login: isUserLoggedIn ? 'login' : 'unlogin',
    });
  };
  const pricingRef = useCardExpo<HTMLDivElement>({
    onExpo: reportPricingExposure,
    threshold: 0,
  });

  const style = isMobile ? { marginTop: '8px' } : {};
  return (
    <div ref={pricingRef} className={styles.pricing} id="price">
      <Card style={{ paddingRight: '0px', paddingLeft: '0px' }}>
        <CardHeader style={{ paddingRight: '16px', paddingLeft: '16px' }}>
          <CardGradientText>
            {content.title}
          </CardGradientText>
          <CardTitle>{content.description}</CardTitle>
        </CardHeader>
        <CardContent className={styles.vipCardContent} style={style}>
          <VipCard />
        </CardContent>
      </Card>
    </div>
  );
}
